




































































































import {
  computed,
  defineComponent,
  ref,
  Ref,
  toRefs,
  watch
} from '@nuxtjs/composition-api'
import CCustomOptionGroupsSelect from '~/components/shared/configurable/form/select/custom/CCustomOptionGroupsSelect.vue'
import MessagesTradeService from '~/services/messages/MessagesTradeService'
import { useDep } from '~/compositions/dependency-container'
import {
  MessagesTradeField,
  MessagesTradeMakesOptions,
  MessagesTradeOptions
} from '~/models/classified/messages-trade'
import { useI18n } from '~/compositions/i18n'
import CCustomSelect from '~/components/shared/configurable/form/select/custom/CCustomSelect.vue'
import { handleError } from '~/utils/http'
import { AxiosError } from 'axios'
import { useSnackbar } from '~/compositions/snackbar'
import { useLogger } from '~/compositions/logger'
import CFormError from '~/components/shared/configurable/form/CFormError.vue'
import CMakeLogo from '~/components/shared/configurable/make/CMakeLogo.vue'
import { computeFieldState } from '~/utils/form'
import { vue3Set } from '~/utils/nuxt3-migration'

const MAKE_OTHER = 32002
export default defineComponent({
  components: {
    CCustomOptionGroupsSelect,
    CCustomSelect,
    CFormError,
    CMakeLogo
  },
  props: {
    classifiedId: { type: Number, required: true },
    errors: { type: Object, required: true },
    classifiedType: { type: String, required: true }
  },
  setup(props, { emit }) {
    const messagesTradeService = useDep(MessagesTradeService)
    const { t } = useI18n()

    const snackbar = useSnackbar()
    const logger = useLogger()
    const { classifiedId, errors } = toRefs(props)

    const internalErrors = ref<{ [key: string]: any }>({})
    const isLoading = ref(false)
    const isTradeMyCarVisible = ref(false)
    const fields = ref<MessagesTradeField[]>([])
    const form = ref({ make: [], inputMake: '', inputModel: '' })
    const makeField = ref<MessagesTradeField | null>(null)
    const allFieldsExceptMake: Ref<MessagesTradeField[]> = ref([])

    watch(errors, newErrors => {
      Object.keys(newErrors).forEach(key => {
        const formatedKey = key.replace('trade_', '')
        vue3Set(internalErrors.value, formatedKey, newErrors[key])
      })
    })
    const makes = computed(() => {
      if (!makeField.value) {
        return []
      }
      return [
        {
          label: t('popular makes').toString(),
          options: (makeField.value.options as MessagesTradeMakesOptions)
            .topMakes
        },
        {
          label: t('all makes').toString(),
          options: (makeField.value.options as MessagesTradeMakesOptions).makes
        }
      ]
    })

    const allMakes = computed(() => {
      return makes.value[1].options
    })

    async function handleMakeChange(makeValue: number | number[]) {
      form.value.make = Array.isArray(makeValue) ? makeValue : [makeValue]
      vue3Set(internalErrors.value, 'make', null)
      vue3Set(internalErrors.value, 'model', null)
      await fetchMessageTrades(form.value.make[0])
      setMakeData()
      emitForm()
    }

    const isMakeOther = computed(() => {
      return form.value.make?.[0] === MAKE_OTHER
    })

    function setMakeData() {
      makeField.value = fields.value.find(
        f => f.field === 'make'
      ) as MessagesTradeField
      allFieldsExceptMake.value = fields.value.filter(f => f.field !== 'make')
      vue3Set(form.value, 'make', [makeField.value?.selected?.value])
    }

    function initFormFields() {
      fields.value.forEach(f => {
        if (f.field !== 'make') {
          vue3Set(form.value, f.field, null)
        }
      })
    }

    function handleCustomSelect(value: number, field: string) {
      vue3Set(form.value, field, value)
      emitForm()
      internalErrors.value[field] = null
    }

    function setFormData() {
      fields.value.forEach(f => {
        if (f.field === 'make' && f.selected?.value === MAKE_OTHER) {
          form.value.inputMake = f.selected?.text
        } else if (f.field === 'model' && f.selected?.value === MAKE_OTHER) {
          form.value.inputModel = f.selected?.text as string
        } else {
          form.value[f.field] = f.selected?.value
        }
      })
    }

    function emitForm() {
      const formData: { [key: string]: any } = {}
      const formKeys = Object.keys(form.value).filter(
        k => !['inputMake', 'inputModel'].includes(k)
      )
      formKeys.forEach(key => {
        if (key === 'make') {
          const selectedMakeOption = allMakes.value?.find(
            o => o.value === form.value[key]?.[0]
          )
          if (isMakeOther.value) {
            formData[`trade_${key}`] = {
              ...selectedMakeOption,
              text: form.value.inputMake
            }
          } else {
            formData[`trade_${key}`] = selectedMakeOption
          }
        } else if (key === 'model') {
          const modelsOptions = fields.value.find(f => f.field === 'model')
            ?.options as MessagesTradeOptions[]
          const selectedModelOption = modelsOptions.find(
            m => m.value === form.value[key]
          )
          if (isMakeOther.value) {
            formData[`trade_${key}`] = {
              value: form.value.make[0],
              text: form.value.inputModel
            }
          } else {
            formData[`trade_${key}`] = selectedModelOption
          }
        } else {
          formData[`trade_${key}`] = form.value[key]
        }
      })
      emit('change-form-field', formData)
    }

    function handleToggleChange(active: boolean) {
      emit('change-form-field', { trade_in: active })
      if (fields.value?.length === 0) {
        fetchMessageTrades()
      }
    }

    async function fetchMessageTrades(makeValue?: number) {
      try {
        isLoading.value = true

        fields.value = await messagesTradeService.fetchMessagesTradeForm(
          classifiedId.value,
          makeValue
        )
      } catch (error) {
        handleError(error as AxiosError, snackbar, logger, t)
      } finally {
        isLoading.value = false
      }
      if (!makeValue) {
        initFormFields()
        setFormData()
        setMakeData()
        emitForm()
      } else {
        setMakeData()
      }
    }

    function handleMakeInput() {
      emitForm()
    }
    function handleModelInput() {
      emitForm()
    }

    return {
      makes,
      form,
      makeField,
      fields,
      handleMakeChange,
      handleCustomSelect,
      allFieldsExceptMake,
      isTradeMyCarVisible,
      handleToggleChange,
      isLoading,
      internalErrors,
      isMakeOther,
      handleMakeInput,
      handleModelInput,
      computeFieldState
    }
  }
})
